import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { SocialIcon } from "react-social-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
    const [showButton, setShowButton] = useState(false);

    // Detect scroll
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Smooth scroll
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <footer className="footer">
            <Container fluid className="footer-container">
                <div className="social-icons">
                    <SocialIcon
                        url="https://www.facebook.com/100092353424441/"
                        network="facebook"
                        bgColor="#3B5998"
                        fgColor="white"
                        style={{ height: 40, width: 40 }}
                    />
                    <SocialIcon
                        url="https://www.instagram.com/umakathinokkula/"
                        network="instagram"
                        bgColor="#E94475"
                        fgColor="white"
                        style={{ height: 40, width: 40 }}
                    />
                    <SocialIcon
                        url="https://www.youtube.com/@salonapntbooking/videos"
                        network="youtube"
                        bgColor="#FF3333"
                        fgColor="white"
                        style={{ height: 40, width: 40 }}
                    />
                    <SocialIcon
                        url="https://api.whatsapp.com/send?phone=919398752916"
                        network="whatsapp"
                        bgColor="#25D366"
                        fgColor="white"
                        style={{ height: 40, width: 40 }}
                    />
                </div>

                <p className="copyright-text">
                    © {new Date().getFullYear()}{" "}
                    <a
                        href="https://salonmanagement.in"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Sree Tech Solutions
                    </a>{" "}
                    - All Rights Reserved
                </p>

                {/* ✅ Terms & Privacy Links */}
                <div className="footer-links">
                    <Link to="/terms">Terms & Conditions</Link>
                    <span className="divider">|</span>
                    <Link to="/privacy">Privacy Policy</Link>
                </div>
            </Container>

            {/* Back to Top button */}
            <button
                className={`back-to-top ${showButton ? "show" : ""}`}
                onClick={scrollToTop}
            >
                <FontAwesomeIcon icon={faChevronUp} />
            </button>
        </footer>
    );
}
